import React from "react";
import { createRoot } from "react-dom/client";
import "./AlertBox.scss";

const CheckIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const XIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const InfoIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
  </svg>
);

let activeRoot = null;

const AlertBox = ({ type, text, onClose }) => {
  const closeAlert = () => {
    const alertContainer = document.getElementById("customAlertBox");
    if (alertContainer) {
      if (activeRoot) {
        activeRoot.unmount();
        activeRoot = null;
      }
      alertContainer.remove();
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={`alertBox ${type}`} onClick={closeAlert}>
      <div className="alertBox__card" onClick={(e) => e.stopPropagation()}>
        <div className={`alertBox__icon ${type}`}>
          {type === 'success' && <CheckIcon />}
          {type === 'error' && <XIcon />}
          {type === 'info' && <InfoIcon />}
        </div>
        <p className="alertBox__text">{text}</p>
        <button className={`alertBox__button ${type}`} onClick={closeAlert}>OK</button>
      </div>
    </div>
  );
};

export function showAlert(type, text, onClose = null) {
  const existingAlert = document.getElementById("customAlertBox");
  if (existingAlert) {
    if (activeRoot) {
      activeRoot.unmount();
      activeRoot = null;
    }
    existingAlert.remove();
  }

  const alertContainer = document.createElement("div");
  alertContainer.id = "customAlertBox";
  document.body.appendChild(alertContainer);

  activeRoot = createRoot(alertContainer);
  activeRoot.render(<AlertBox type={type} text={text} onClose={onClose} />);
}
